import { render, staticRenderFns } from "./cv_tag_form.vue?vue&type=template&id=5187e2d0&lang=pug&"
import script from "./cv_tag_form.vue?vue&type=script&lang=js&"
export * from "./cv_tag_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports